import React from 'react'
import PropTypes from 'prop-types'

import { CompteTiersTableHead } from '../components/Table/data'
import BodyContainer from '../components/bodyContainer'

const CompteTiersList = ({
  fetchData,
  isLoadingCompteTiersList,
  compteTiers,
  compteTiersCount,
  errorMessage,
  removeError,
  isErrorFetch,
  pageLimitChanged,
  pageChanged,
  success,
  isSuccessRefresh,
  resetSuccessAction,
  searchData,
  onCloseReset,
}) => {
  return (
    <BodyContainer
      //EtatdisplayMode
      isDisplayMode={false}
      //TableMode
      actionButton={true}
      tableHead={CompteTiersTableHead}
      //Commonfields
      globalID={'CompteTiers'}
      searchPlaceholder={'Rechercher par compte tiers'}
      title={'Gestion compte tiers'}
      fetchData={fetchData}
      loadingData={isLoadingCompteTiersList}
      dataList={compteTiers}
      countData={compteTiersCount}
      errorMessage={errorMessage}
      removeError={removeError}
      removeErrorConfig={() => {}}
      isErrorFetch={isErrorFetch}
      pageLimitChanged={pageLimitChanged}
      pageChanged={pageChanged}
      searchData={searchData}
      onCloseReset={onCloseReset}
      resetSuccessAction={resetSuccessAction}
      success={success}
      isSuccessRefresh={isSuccessRefresh}
      isCompteTiers={true}
    />
  )
}
CompteTiersList.propTypes = {
  compteTiers: PropTypes.array,
  fetchData: PropTypes.func,
  isLoadingCompteTiersList: PropTypes.bool,
  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  searchKeys: PropTypes.func,
  onCloseReset: PropTypes.func,
  searchData: PropTypes.func,
  success: PropTypes.bool,
  compteTiersCount: PropTypes.number,
  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,
}
export default CompteTiersList
